import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';
import UserTypeGate, { USER_TYPE_IDS } from '@components/UserTypeGate';
import HomeIndex from '@routes/StudentHome/routes/HomeIndex';
import Campus from '@routes/StudentHome/routes/Campus';
import Curriculum from '@routes/StudentHome/routes/Curriculum';

const LazyStudentRoot = React.lazy(
	() => import(/* webpackChunkName: 'StudentHome' */ './components')
);

export default () => {
	return {
		path: 'student',
		element: (
			<AsyncLoading
				component={
					<UserTypeGate expectedTypeId={USER_TYPE_IDS.STUDENT}>
						<LazyStudentRoot />
					</UserTypeGate>
				}
			/>
		),
		children: [HomeIndex(), Campus(), Curriculum()],
	};
};
